import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../components/tabs/table-tab";
import { CATEGORIES } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from "../models/ColumnDefinitions/CategoryColumns";
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from "../models/search/CategorySearch";
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { getCategories } from "../services/categoriesService";
import { deleteCategory } from "../services/categoryService";
import { getSiteNamesWithPagination } from "../services/siteService";

interface CategoryTabProps {
    setBusy: (isBusy: boolean) => void;
}

const CategoryTab: FC<CategoryTabProps> = ({ setBusy }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.categories);
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, []);

    const handleDelete = (categoryId): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteCategory(categoryId)
                .then(result => {
                    return resolve(result);
                })
                .catch(error => {
                    return reject(error);
                })
                .finally(() => {
                    setBusy(false);
                })
        })
    }

    // --> start context
    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = CATEGORIES;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }
    // <-- end context

    return (<TableContextProvider
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        dataMethod={getCategories}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        deleteMethod={handleDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }} >
        <TableTab
            title={title}
            selectRows={false}
            cyName="categories"/>
    </TableContextProvider >
    );
};

export default CategoryTab;
